export const maxTableRows: number = 5;